// APP TEXT
export const APP_TITLE        = 'LOM APP'
export const APP_COMPANY_NAME = 'Lombriser Engineering GmbH'
export const APP_DESCRIPTION  = 'LOM APP is a web-app for develompment.'
export const APP_VERSION = `${process.env.REACT_APP_VERSION}`

// UI CONSTANTS

// URLS
